<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                {{'header.eligibility.titleList.AllEligibilityRecords' | translate}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{'header.eligibility.titleList.EligibilityData' |
                                    translate}}</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    {{'header.eligibility.titleList.AddNewRecord' | translate}}
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.eligibility.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty start  -->

                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ElgbForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.eligibility.titleList.AddNewEligibilityRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{'header.eligibility.titleList.AddNewEligibilityInformation' |
                                                translate}}</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.eligibility.titleList.UpdateEligibilityRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.eligibility.titleList.UpdateSelectedEligibilityInformation' |
                                                translate}}
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.eligibility.titleList.DeleteEligibilityRecord' |
                                                    translate}}</b></h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.eligibility.titleList.DeleteSelectedEligibilityInformation' |
                                                translate}}
                                            </p>
                                        </div>
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> {{'header.eligibility.titleList.ListNo' |
                                                            translate}}</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="ElgblistNo" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="ElgblistNo2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="ElgblistNo3" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.Colg' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbClg" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            

                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row mr-0">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk "></span>{{'header.eligibility.titleList.Valid'
                                                                | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="ElgbValid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>{{'header.eligibility.titleList.Change'
                                                                | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="ElgbChng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.RgNo' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbRgNo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>{{'header.eligibility.titleList.Elgb'
                                                                | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="Eligibility"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.Batch' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbBatch" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.SrNo' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbSrNo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.ElgbNo' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbNo" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.Colg' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbColg" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.Name' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbName" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-1">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.eligibility.titleList.Valid' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="ElgbValid2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="ElgbValid3" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="submitButton"
                                                (click)="submit()">{{'header.eligibility.titleList.Submit' |
                                                translate}}</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="editButton"
                                                (click)="update()">{{'header.eligibility.titleList.Update' |
                                                translate}}</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="deleteButton"
                                                (click)="delete()">{{'header.eligibility.titleList.Delete' |
                                                translate}}</button>
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                (click)="addnewrecord('false')">{{'header.eligibility.titleList.Back' |
                                                translate}}</button>
                                        </div>
                                        <div class="table-responsive">
                                            <table id="datatable"
                                                class="table table-striped table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>

                                                        <th class="f600">
                                                            {{'header.eligibility.table.ElgRg'| translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Batch' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.SrNo' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Name' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.RegnNo' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Elgb' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Colg' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Valid' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Change' | translate}}
                                                        </th>
                                                        <th class="f600">

                                                            {{'header.eligibility.table.Message' | translate}}
                                                        </th>
                                                        <th width="10%" class="f600 text-center">
                                                            {{'header.eligibility.table.Action' | translate}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr>
                                                        <!-- *ngFor="let faculty of facultyList;" -->
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td>

                                                        </td>
                                                        <td class="text-center">

                                                            <a class="btn-floating" title="Edit"
                                                                (click)="edit('true','faculty')">
                                                                <!--  -->
                                                                <i class="fa fa-edit"></i>
                                                            </a>
                                                            <a class="btn-floating" title="Delete"
                                                                (click)="deletee('true','faculty')">
                                                                <!--  -->
                                                                <i class="fas fa-trash"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>